import { createContext, useState, useEffect, useCallback } from "react";
import { getData } from "./Api";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    const fetchSettings = useCallback(async () => {
        try {
            const response = await getData("/settings");
            if (response.success) {
                setSettings(response.data);
            }
        } catch (error) {
            console.error("Error loading settings:", error);
        }
    }, []);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return (
        <SettingsContext.Provider value={{ settings, refreshSettings: fetchSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};
